import React from "react";
import { HeaderViewModel } from "./HeaderViewModel.csharp";
import { PageTheme } from "../../Base/Themes/PageTheme.csharp";
import { PictureProfile } from "../../../../ResizedImage/PictureProfile.csharp";
import { ResponsivePicture } from "../../../ReactComponents/responsivePicture/responsivePicture";

type Props = {
    model: HeaderViewModel;
    translationShowMore: string;
    defaultProfile: PictureProfile;
};

export const HappeningHeader: React.FC<Props> = ({ model, translationShowMore, defaultProfile }) => {
    const { variant, title, subtitle, image, theme, customThemeColors, imagePosition, intro, imageCopyright } = model;
    const imagePositionMap: Record<number, string> = {
        0: "right",
        1: "left",
        2: "center",
    };
    const imagePositionName = imagePositionMap[imagePosition] ?? "left";
    const imagePositionClass = image ? `HappeningHeader--${imagePositionName}Image` : "HappeningHeader--noImage";

    const themeRaw = PageTheme[theme] ?? "whiteBlack";
    const themeName = themeRaw.charAt(0).toLowerCase() + themeRaw.slice(1);

    const headerModifier = `HappeningHeader--${themeName}`;
    const headerVariant = variant === 0 ? "HappeningHeader--generic" : "";

    const seeMoreButtonModifier = `HappeningHeader__arrowSeeMore--${themeName}`;

    const customStyle =
        theme === PageTheme.Custom && customThemeColors
            ? {
                  background: customThemeColors.customThemeBackgroundColor,
                  color: customThemeColors.customThemeFontColor,
              }
            : {};

    const customArrowStyle =
        theme === PageTheme.Custom && customThemeColors
            ? {
                  cursor: "pointer",
                  background: `center no-repeat url("data:image/svg+xml;charset=utf-8,%3Csvg width='34' height='54' xmlns='http://www.w3.org/2000/svg' fill='${customThemeColors.customThemeFontColor.replace(
                      "#",
                      "%23"
                  )}' %3E%3Cpath d='M15.313 47.87L1.672 31.403 0 32.813 16.452 52.5l16.36-19.688-1.67-1.41L17.5 47.872V0h-2.188z'/%3E%3C/svg%3E")`,
              }
            : {};

    const scrollToMainBody = (e: React.MouseEvent) => {
        e.preventDefault();
        const target = document.getElementById("mainbody");
        if (target) {
            target.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <div
            className={`newHappeningHeader ${headerModifier} ${imagePositionClass} ${headerVariant}`}
            style={customStyle}
        >
            <div className="newHappeningHeader__container">
                <div className="newHappeningHeader__inner">
                    <h1 className="newHappeningHeader__title">
                        <span>
                            <span dangerouslySetInnerHTML={{ __html: title.replace("&amp;shy", "&shy;") }} />
                            <span
                                className="newHappeningHeader__subtitle"
                                dangerouslySetInnerHTML={{ __html: subtitle }}
                            />
                        </span>
                        <div className="newHappeningHeader__seeMore-container">
                            <button
                                type="button"
                                className={`${seeMoreButtonModifier} newHappeningHeader__seeMore`}
                                onClick={scrollToMainBody}
                                style={customArrowStyle}
                            >
                                <span className="visuallyHidden">{translationShowMore}</span>
                            </button>
                        </div>
                    </h1>
                    <div className="newHappeningHeader__intro">
                        <div className="newHappeningHeader__intro-inner" dangerouslySetInnerHTML={{ __html: intro }} />
                        <div className="newHappeningHeader__seeMore-container-intro">
                            <button
                                type="button"
                                className={`${seeMoreButtonModifier} newHappeningHeader__seeMore`}
                                onClick={scrollToMainBody}
                                style={customArrowStyle}
                            >
                                <span className="visuallyHidden">{translationShowMore}</span>
                            </button>
                        </div>
                    </div>
                </div>

                {image && (
                    <figure className="newHappeningHeader__image">
                        <ResponsivePicture model={image} profile={defaultProfile} />
                        {imageCopyright && (
                            <figcaption className="newHappeningHeader__image-copyright">
                                &copy; {imageCopyright}
                            </figcaption>
                        )}
                    </figure>
                )}
            </div>
        </div>
    );
};
